import Axios from "axios"
import type I_BaseAPIResponse from "src/common_interfaces/I_BaseAPIResponse"
import AxiosConfig from "src/utilities/AxiosConfig"
import snackBar from "src/utilities/snackBar/SnackBar"
import type { I_BatchUpdateRequestPayload } from "../types"

const ENDPOINT = `${process.env.REACT_APP_API_URL}/api/batchupdaterequest`

/** Returns null when the request is missing or the caller may not read it. */
const GetBatchUpdateRequestPayload = async (
	batchUpdateRequestId: number,
): Promise<I_BatchUpdateRequestPayload | null> => {
	try {
		const response = await Axios.get<
			I_BaseAPIResponse<I_BatchUpdateRequestPayload>
		>(
			`${ENDPOINT}/${batchUpdateRequestId}/payload`,
			AxiosConfig.configValue("min"),
		)

		if (response.data.HasError) {
			snackBar({
				type: "error",
				text: response.data.ErrorMessage,
				timeout: 4000,
			})
			return null
		}

		return response.data.Data
	} catch (error) {
		console.error("GetBatchUpdateRequestPayload failed:", error)
		snackBar({
			type: "error",
			text: "Failed to load the batch update request",
			timeout: 4000,
		})
		return null
	}
}

export default GetBatchUpdateRequestPayload
